export const OZON_ENTITIES = {
  PLACEMENT_TYPES: {
    PROVIDE_FULL_CONTROL: ['OZON_SKU', 'OZON_SKU_TOP', 'OZON_PAY_PER_CLICK'],
    WITHOUT_STRATEGY_CONTROL: ['OZON_SKU_OVERTOP'],
    NOT_ALLOWED: ['OZON_BANNER', 'OZON_VIDEO_BANNER', 'OZON_PAY_PER_ORDER', 'OZON_SEARCH_PROMO_OLD']
  },
  STRATEGIES: {
    ALLOWED: ['MANUAL', 'TARGET_BIDS']
  }
};

